module.exports = __webpack_public_path__ + "img/Upload-file-3.2ee70415.svg";